interface ClockHistoryIconProps {
  strokeColor?: string;
  /** Icon size in pixels (width and height). Defaults to 20. */
  size?: number;
}

/** Clock face with hands, used as the row shortcut to a case's history. */
export const ClockHistoryIcon = (props: ClockHistoryIconProps) => {
  const size = props.size ?? 20;

  return (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
<g clip-path="url(#clip0_4936_86492)">
<path d="M15.1333 9L13.8004 7.66667L12.4666 9M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C10.2013 2 12.1257 3.18542 13.1697 4.95273M8 4.66667V8L10 9.33333" stroke="#0056D6" stroke-width="1.17" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_4936_86492">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
  );
};
